import * as React from "react"

const SvgComponent = (props) => (
    <svg width={512} height={512} {...props}
     viewBox={'0 0 512 512'}>
        <path
            stroke={"#F72585"}
            fill={"#F72585"}
            viewBox={`0 0 512 512`}
            d="M352 464c-88 0-160-72-160-160s72-160 160-160 160 72 160 160-72 160-160 160zm0-304c-79 0-144 65-144 144s65 144 144 144 144-65 144-144-65-144-144-144zm0 256c-62 0-112-50-112-112s50-112 112-112 112 50 112 112-50 112-112 112zm0-208c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm-40 256H0v-64h240v16H16v32h296zm-72-48H16v-64h200v16H32v32h208zm-24-48H32v-64h176v16H48v32h168zm-8-48H0v-64h208v16H16v32h192zm0-48H16v-64h216v16H32v32h176zm24-48H0v-64h280v16H16v32h216zm48-48H16v-64h312v48h-16v-32H32v32h248zm32-48H0V64h312zM16 112h280V80H16z"/>
    </svg>
)

export default SvgComponent
